import React from 'react'
import { compose } from 'recompose'
import { inject, observer } from 'mobx-react'
import { LocaleProvider } from 'antd'
import en from 'antd/lib/locale-provider/en_US'
import th from 'antd/lib/locale-provider/th_TH'
import zh from 'antd/lib/locale-provider/zh_CN'
import moment from 'moment'
import 'moment/locale/th'
import 'moment/locale/zh-cn'
const locales = {
  en,
  th,
  zh
}
const momentLocales = {
  en: 'en',
  th: 'th',
  zh: 'zh-cn'
}
// console.log({ locales })
const ConnectedLocaleProvider = ({ children, i18n: { locale } }) => ((
  moment.locale(momentLocales[locale]),
  <LocaleProvider locale={locales[locale]}>
    {children}
  </LocaleProvider>
))

export default compose(
  inject('i18n'),
  observer
)(ConnectedLocaleProvider)



// WEBPACK FOOTER //
// ./src/App/providers/locale.js